// Mock data for fitness influencer portfolio

export const influencerData = {
  name: "Alex Morgan",
  tagline: "I Don't Just Create Fitness Content",
  subtitle: "I Build Brands That Convert",
  followers: "1.4M+",
  monthlyReach: "9.2M",
  engagement: "5.8%",
  usaAudience: "72%",
  instagram: "@alexmorgan_fit",
  youtube: "AlexMorganFitness",
  email: "collabs@alexmorgan.fit"
};

export const brands = [
  { name: "Nike", logo: "NIKE" },
  { name: "Gymshark", logo: "GYMSHARK" },
  { name: "MyProtein", logo: "MYPROTEIN" },
  { name: "Under Armour", logo: "UNDER ARMOUR" },
  { name: "Adidas", logo: "ADIDAS" }
];

export const audienceInsights = {
  totalFollowers: "1.4M+",
  demographics: {
    usa: 72,
    canada: 12,
    uk: 8,
    australia: 5,
    other: 3
  },
  ageGroups: [
    { range: "18-24", percentage: 28 },
    { range: "25-34", percentage: 45 },
    { range: "35-44", percentage: 20 },
    { range: "45+", percentage: 7 }
  ],
  gender: {
    male: 58,
    female: 42
  },
  topCities: [
    { city: "Los Angeles", percentage: 18 },
    { city: "New York", percentage: 15 },
    { city: "Chicago", percentage: 12 },
    { city: "Miami", percentage: 10 },
    { city: "Houston", percentage: 8 }
  ]
};

export const stats = [
  { label: "Total Followers", value: "1.4M+", icon: "users" },
  { label: "Monthly Reach", value: "9.2M", icon: "eye" },
  { label: "Engagement Rate", value: "5.8%", icon: "heart" },
  { label: "USA Audience", value: "72%", icon: "map-pin" }
];

export const contentShowcase = [
  {
    id: 1,
    type: "reel",
    thumbnail: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&h=800&fit=crop",
    views: "2.4M",
    engagement: "8.2%"
  },
  {
    id: 2,
    type: "reel",
    thumbnail: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&h=800&fit=crop",
    views: "1.8M",
    engagement: "7.5%"
  },
  {
    id: 3,
    type: "reel",
    thumbnail: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=600&h=800&fit=crop",
    views: "3.1M",
    engagement: "9.1%"
  },
  {
    id: 4,
    type: "reel",
    thumbnail: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=600&h=800&fit=crop",
    views: "2.2M",
    engagement: "6.8%"
  }
];

export const caseStudies = [
  {
    id: 1,
    brand: "Gymshark",
    campaign: "New Collection Launch",
    before: {
      reach: "500K",
      engagement: "3.2%",
      conversions: "1,200"
    },
    after: {
      reach: "2.8M",
      engagement: "8.4%",
      conversions: "12,400"
    },
    roi: "450%"
  },
  {
    id: 2,
    brand: "MyProtein",
    campaign: "Summer Shred Series",
    before: {
      reach: "800K",
      engagement: "4.1%",
      conversions: "2,100"
    },
    after: {
      reach: "4.2M",
      engagement: "9.2%",
      conversions: "18,600"
    },
    roi: "380%"
  }
];

export const services = [
  {
    id: 1,
    title: "Sponsored Content",
    description: "High-impact posts and reels that drive brand awareness and conversions",
    icon: "video"
  },
  {
    id: 2,
    title: "Product Reviews",
    description: "Authentic reviews that build trust and influence purchasing decisions",
    icon: "star"
  },
  {
    id: 3,
    title: "Brand Ambassadorship",
    description: "Long-term partnerships that create lasting brand loyalty",
    icon: "handshake"
  },
  {
    id: 4,
    title: "Event Appearances",
    description: "Live events and product launches that generate buzz and engagement",
    icon: "calendar"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Marketing Director, Gymshark",
    content: "Alex delivered results beyond our expectations. The engagement rates were 3x higher than our previous campaigns.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Brand Manager, MyProtein",
    content: "Working with Alex was seamless. Professional, creative, and most importantly - drove real conversions for our brand.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Roberts",
    role: "CMO, FitGear",
    content: "Alex understands the fitness market inside out. Our ROI increased by 400% in just 3 months of collaboration.",
    rating: 5
  }
];